// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db","window":"modal_window__Akyot","closeIcon":"modal_closeIcon__HrLJF","body":"modal_body__MX-ja"};